// Disables a link on click and replaces link text
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "disablePinCheckbox",
    "signedHoursSheet",
    "instructorResultsFieldset",
    "instructorResultsActions"
  ]

  disablePinCheckboxTarget: HTMLInputElement
  signedHoursSheetTargets: Array<HTMLElement>
  instructorResultsFieldsetTarget: HTMLFieldSetElement
  instructorResultsActionsTarget: HTMLElement

  updateDisabledPinElements() {
    if(this.disablePinCheckboxTarget.checked) {
      this.enableSignedUpload()
    } else {
      this.disableSignedUpload()
    }
  }

  enableSignedUpload() {
    this.instructorResultsFieldsetTarget.disabled = false
    this.instructorResultsActionsTarget.classList.remove('d-none')
    this.signedHoursSheetTargets.map((hoursSheet) => {
      hoursSheet.classList.remove('d-none')
    })
  }

  disableSignedUpload() {
    this.instructorResultsFieldsetTarget.disabled = true
    this.instructorResultsActionsTarget.classList.add('d-none')
    this.signedHoursSheetTargets.map((hoursSheet) => {
      hoursSheet.classList.add('d-none')
    })
  }

}
